import mq from '_utils/styles/mq';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  position: relative;
  color: #ffffff;
  overflow: visible;
  background: #090d46;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.18);
`;

export const Content = styled.div`
  padding: 18px 8px;

  ${mq("md")} {
    padding: 18px 8px;
  }
  ${mq("lg")} {
    padding: 18px 24px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  max-width: 1440px;
  margin: auto;
  position:relative;
  ${mq("lg")} {
    gap: 18px;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const DropdownTrigger = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0;
  cursor: pointer;
  text-align: left;
  border-radius: 50%;
  transition: background 160ms ease, border-color 160ms ease;
  outline: none;
`;

export const ArrowIcon = styled.span<{ isOpen?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 8px;
  transition: transform 160ms ease;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const CityText = styled.span`
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  display: inline-block;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${mq("md")} {
    font-size: 24px;
    font-weight: 800;
    line-height: 1.2;
  }
  ${mq("lg")} {
    font-size: 36px;
    font-weight: 800;
    line-height: 1.2;
  }

`;

export const MetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-top: 6px;
  display: none;
  ${mq("md")} {
    display: flex;
  }
  ${mq("lg")} {
    display: flex;
  }
`;

export const MetaItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: rgba(255, 255, 255, 0.88);
  font-size: 0.95rem;
  line-height: 1.3;
  min-width: 0;
  white-space: nowrap;
`;

export const MetaIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: -1px;
  width: 16px;
  height: 14px;
  color: #ffffff;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;

  @media (min-width: 768px) {
    justify-content: flex-end;
    min-width: 260px;
  }
`;

export const Button = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  border-radius: 999px;
  background: #1c6cff;
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 700;
  min-height: 32px;
  text-align: center;
  transition: background 160ms ease;
  ${mq("md")} {
    font-size: 14px;
    font-weight: 800;
    padding: 4px 16px;
    min-height: 32px;
  }
  ${mq("lg")} {
    font-size: 16px;
    font-weight: 800;
    padding: 12px 24px;
    min-height: 44px;
  }

  &:hover,
  &:focus-visible {
    background: #115ce0;
    outline: none;
  }
`;

export const DropdownPanel = styled.div`
  position: absolute;
  top: calc(100% + 28px);
  left: 0;
  right: 24px;
  width: auto;
  max-width: 320px;
  background: #090d46;
  border-radius: 8px;
  border: 1px solid #f7f7f7;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.12);
  z-index: 10;
`;

export const DropdownList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 8px;
  display: grid;
  gap: 8px;
`;

export const DropdownListItem = styled.li`
  border-radius: 8px;
  overflow: hidden;
`;

export const DropdownLink = styled.a<{ selected?: boolean }>`
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding:8px;
  border-radius: 8px;
  color: ${({ selected }) => (selected ? '#ffdd00' : '#ffffff')};
  background: ${({ selected }) => (selected ? 'transparent' : 'transparent')};
  text-decoration: none;
  font-size: 20px;
  line-height: 26px;
  font-weight: ${({ selected }) => (selected ? '700' : '400')};
  cursor: ${({ selected }) => (selected ? 'default' : 'pointer')};
  pointer-events: ${({ selected }) => (selected ? 'none' : 'auto')};
  transition: background 160ms ease, color 160ms ease;
  &:not([data-selected='true']):hover,
  &:not([data-selected='true']):focus-visible {
    background: rgba(255, 255, 255, 0.08);
    outline: none;
  }
`;

export const DropdownLinkText = styled.span`
  display: inline-block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
